export const imageConverter = {
  methods: {
    srcToBlob(src, type, quality) {
      return new Promise((resolve, reject) => {
        let canvas = window.document.createElement('canvas');
        let ctx = canvas.getContext('2d');
        let img = new Image();
        img.src = src;
        img.onload = function() {
          canvas.height = this.naturalHeight;
          canvas.width = this.naturalWidth;
          ctx.drawImage(this, 0, 0);
          canvas.toBlob(blob => resolve(blob), type, quality);
        };
        img.onerror = reject;
      });
    },
  },
};
